import React, { useContext } from 'react';
import { Modal, Button} from 'react-bootstrap';
import { Store } from '../Store';
import { InfoSquareFill } from 'react-bootstrap-icons';

const NoticeModal = ({ show, handleClose }) => {
    const { state } = useContext(Store);  
    const { noticeContent} = state;

  // useEffect(() => {
  //       const fetchNoticeContent = async () => {
  //         try {
  //           const { data } = await axios.get(`${baseUrl}/extra/notice`);
  //           setNoticeContent(data);
  //          } catch (error) {
  //           console.error('Error fetching notice content:', error);
  //         }
  //       };
  //       fetchNoticeContent();
  //     }, [baseUrl]); 
  return (
    <Modal show={show} onHide={handleClose} keyboard={false} backdrop="static">
      <Modal.Header className='bg-danger text-white' closeButton>
        <Modal.Title className="w-100 text-center"> <InfoSquareFill/> PLEASE NOTE</Modal.Title>
      </Modal.Header>
      <Modal.Body className='text-center text-danger fw-bold'> 
        <p>{noticeContent?.noticeContent}</p>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NoticeModal;